export const TimesTI = [
    {
        area:"Front-End",
        cor:"#00bfff"
    },
    {
        area:"Back-End",
        cor:"#a52a2a"
    },
    {
        area:"Mobile",
        cor:"#ff8c00"
    },
    {
        area:"Adicional",
        cor:"#006400"
    },
    {
        area:"Pessoal",
        cor:"#bc8f8f"
    },
]